import { Store, select } from '@ngrx/store';
import {
  createSelector,
  createFeatureSelector,
  ActionReducerMap
} from '@ngrx/store';
import { Application } from '../../../models/application.model';
import * as fromApplication from './applications.reducer';


// export const reducers: ActionReducerMap<any> = {
//   message: fromApplication.applicationReducer
// };

export const selectApplicationState = createFeatureSelector<fromApplication.State>('applicationReducer');


export const { selectAll: selectAllApplications } = fromApplication.applicationAdapter.getSelectors(
  selectApplicationState
);

export const selectAddApplicationCompleted = createSelector(selectApplicationState,
  fromApplication.getSiteStatus
);
// export const { selectEntities: selectAllEntities } = fromApplication.applicationAdapter.getSelectors(
//   selectApplicationState
// );

// export const { selectAll: selectAllApplicationsByCompanyId } = fromApplication.applicationAdapter.getSelectors(
//   selectApplicationState
// );


export const selectAllCourses = createSelector(
  selectApplicationState,
  applicationsState => {
    const allCourses = Object.values(applicationsState.entities);
    allCourses.sort();
    return allCourses;
  }
);

export interface FeatureState {
  counter: number;
}

export interface AppState {
  feature: FeatureState;
}

export const selectFeature = createFeatureSelector< FeatureState>('feature');

export const selectFeatureCount = createSelector(
  selectFeature,
  (state: FeatureState) => state.counter
);

export const {
  selectIds: applicationIds,
  selectEntities: applicationEntities,
  selectAll: allApplications,
  selectTotal: totalApplications
} = fromApplication.applicationAdapter.getSelectors(selectApplicationState);

export const selectApplicationsByAppId = createSelector(
  allApplications,
  (applications: Application[], { appId }: { appId: number }) => applications.filter(application => application.appId === appId)
);

// export const selectApplicationsByCompanyId = createSelector(
//   allApplications,
//   (applications: Application[], { id }: { id: string }) => applications.filter(application => application.companyId === id)
// );

// export const selectApplicationsByCompanyIdSiteId = createSelector(
//   allApplications,
//   (applications: Application[], { companyId: companyId ,  siteId: siteId }: { companyId: string,  siteId: string }) => applications.filter(application => application.companyId === companyId && application.siteId === siteId)
// );

// export const selectApplicationsByCompanyIdAndDate = createSelector(
//   allApplications,
//   (applications: Application[], { id }: { id: string }) => applications.filter(application => application.companyId === id)
// );

// export const selectApplicationsByCompanyIdApplicationId = createSelector(
//   allApplications,
//   (applications: Application[], { id, applicationId }: { id: string, applicationId: string }) => applications.filter(application => (application.companyId === id && application.id === applicationId) )
// );

